module.exports = __webpack_public_path__ + "static/media/color-bg.b1c923df.jpg";